import { styled, typography } from '@pulse-web-ui/theme';

export const File = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 62px 8px 8px;
  background-color: ${({ theme }) => theme.colors.neutral[10]};
  border-radius: calc(${({ theme }) => theme.common.radius} * 3);
`;

export const IconContainer = styled.span`
  padding: 22px 20px;
  background-color: ${({ theme }) => theme.colors.neutral[20]};
  border-radius: calc(${({ theme }) => theme.common.radius} * 2);
`;

export const RemoveIcon = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  padding: 6px 6px 12px 12px;
`;

export const FileInfo = styled.div`
  max-width: calc(100% - 80px);
`;

export const NameWrapper = styled.p`
  display: flex;
  margin-bottom: 4px;
`;

export const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Size = styled.span`
  ${typography.regular12};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
